
import type { z } from 'zod';

interface StandardSchemaV1<Input = unknown, Output = Input> {
  readonly '~standard': {
    readonly version: 1;
    readonly vendor: string;
    readonly validate: (value: unknown) =>
      | { readonly value: Output; readonly issues?: undefined }
      | { readonly issues: ReadonlyArray<{ readonly message: string; readonly path?: ReadonlyArray<string | number> }> };
    readonly types?: { readonly input: Input; readonly output: Output };
  };
}

export function zodValidator<TSchema extends z.ZodType>(
  schema: TSchema,
): StandardSchemaV1<z.input<TSchema>, z.output<TSchema>> {
  return {
    '~standard': {
      version: 1,
      vendor: 'cheddule-zod',
      validate: (value: unknown) => {
        const result = schema.safeParse(value);
        if (result.success) {
          return { value: result.data as z.output<TSchema> };
        }
        return {
          issues: result.error.issues.map((issue) => ({
            message: issue.message,
            path: issue.path,
          })),
        };
      },
    },
  };
}

export function firstFieldError(errors: ReadonlyArray<unknown> | undefined): string | undefined {
  for (const err of errors ?? []) {
    if (typeof err === 'string') return err;
    if (typeof err === 'object' && err !== null && 'message' in err) {
      const message = (err as { message?: unknown }).message;
      if (typeof message === 'string' && message.length > 0) return message;
    }
  }
  return undefined;
}
